import React, { Component } from 'react';
import styled from 'styled-components';
import swipe from '../../images/instore/icons/horizontalswipe.svg';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const StyledHorizontalSwipe = styled.div`
  width: 120px;
  height: 120px;
  position: absolute;
  left: 0; right: 0; margin: 0 auto;
  top: 0;
  z-index: 20;
  border: 3px solid rgba(255,255,255,.5);
  border-radius: 12px;
  background: url(${swipe}) no-repeat, rgba(0,0,0,1);
  background-position: 45% center;
  pointer-events: none;
  
  @keyframes move {
    0% {
      transform: translate3d(0,0,0);
    }
    25% {
      transform: translate3d(-10px,0,0);
    }
    50% {
      transform: translate3d(10px,0,0);
    }
    75% {
      transform: translate3d(0,0,0);
    }
  }

  animation: move 1s 1s ease-in-out;
`

class HorizontalSwipe extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false }
  }
  componentDidMount() {

    setTimeout(() => {
      this.setState({visible: true});
    }, 200);

    setTimeout(() => {
      this.setState({visible: false});

    }, 2200);

  }
  render = () => {
    return (
      <ReactCSSTransitionGroup
        transitionName="swipeGesture"
        transitionAppear={true}
        transitionEnter={true}
        transitionLeave={true}
        transitionAppearTimeout={3000}
        transitionLeaveTimeout={3000}
        transitionEnterTimeout={3000}
      >
      { this.state.visible ? 
        <StyledHorizontalSwipe key='swipeicon'/>
      : null }
      </ReactCSSTransitionGroup>
    )
  }
}

export default HorizontalSwipe;


// WEBPACK FOOTER //
// ./src/components/instore/SwipeGesture.js